import { create } from 'zustand';

const useBacktestStore = create((set) => ({
  // data
  stats: null,
  equitySeries: [],
  lastUpdated: null,

  // connection / loading state
  status: 'idle', // 'idle' | 'connecting' | 'loading' | 'ready' | 'error'
  error: null,

  // actions
  setConnecting: () => set({ status: 'connecting', error: null }),
  setLoading: () => set({ status: 'loading', error: null }),
  setReady: ({ stats, equitySeries }) =>
    set({
      stats,
      equitySeries: Array.isArray(equitySeries) ? equitySeries : [],
      status: 'ready',
      error: null,
      lastUpdated: new Date().toISOString()
    }),
  setError: (error) =>
    set({
      status: 'error',
      error: error || 'Unknown error'
    }),
  reset: () =>
    set({
      stats: null,
      equitySeries: [],
      lastUpdated: null,
      status: 'idle',
      error: null
    })
}));

export default useBacktestStore;
